import * as React from 'react';
import { formatNumber } from 'src/share/utils/formatNumbers';
import { timestampToDateTimeStringShort, formatCapitalized } from 'src/share/utils/utils';

export const CustomTooltip = (props) => {
    const { active, payload } = props;
    if (active && payload) {
        return (
            <div className="custom-tooltip">
                <p>{payload[0] && payload[0].payload && payload[0].payload.name}</p>
                <p>{`count: ${formatNumber(payload[0] && payload[0].value || 0)}`}</p>
            </div>
        );
    }
    return null;
}
export const CustomTooltipCountries = (props) => {
    const { active, payload } = props;
    if (active && payload) {
        return (
            <div className="custom-tooltip">
                <p>{payload[0] && payload[0].payload && payload[0].payload.name}</p>
                <p>{`count: ${payload[0] && payload[0].value}`}</p>
            </div>
        );
    }
    return null;
}

export const CustomTooltipYear = (props) => {
    const { active, payload } = props;
    if (active && payload && payload[0] && payload[1] && payload[0].payload && payload[1].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{payload[0].payload.year}</b></p>
                <p style={{ color: payload[0].color }}>{`Open cases: ${payload[0].payload.opened || 0}`}</p>
                <p style={{ color: payload[1].color }}>{`Closed cases: ${payload[1].payload.closed || 0}`}</p>
            </div>
        );
    }
    return null;
}
export const CustomTooltipGASessions = (props) => {
    const { active, payload } = props;
    if (active && payload && payload[0] && payload[0].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{payload[0].payload.date}</b></p>
                <p style={{ color: payload[0].color }}>{`${payload[0].payload.count || 0} views`}</p>
            </div>
        );
    }
    return null;
}
export const CustomTooltipGAWeekComparison = (props) => {
    const { active, payload } = props;
    if (active && payload && payload[0] && payload[1] && payload[0].payload && payload[1].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{payload[0].payload.day}</b></p>
                <p style={{ color: payload[0].color }}>{`Last: ${payload[0].payload.last || 0} sessions`}</p>
                <p style={{ color: payload[1].color }}>{`This: ${payload[1].payload.current || 0} sessions`}</p>

            </div>
        );
    }
    return null;
}

export const ChartDaysCustomTooltip = (props) => {
    const { active, payload } = props;
    if (active && payload && payload[0] && payload[0].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{timestampToDateTimeStringShort(payload[0].payload.name)}</b></p>
                <p style={{ color: payload[0].color }}>{`${props.dataKey}: ${formatNumber(payload[0].payload.count || 0)}`}</p>
            </div>
        );
    }
    return null;
}

export const CustomMonthlyHighlightsTooltip = (props) => {
    const { active, payload } = props;
    if (active && payload && payload[0] && payload[1] && payload[0].payload && payload[1].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{payload[0].payload.month}</b></p>
                <p style={{ color: payload[0].color }}>{`Cases: ${payload[0].payload.cases || 0}`}</p>
                <p style={{ color: payload[1].color }}>{`Alerts: ${payload[1].payload.alerts || 0}`}</p>
                <p style={{ color: payload[2].color }}>{`Alerted Cases Closed: ${payload[2].payload.alertedCasesClosed || 0}`}</p>
            </div>
        );
    }
    return null;
}

export const CustomChartByDateTooltip = (props) => {
    const { active, dataKey, dateKey, payload } = props;
    if (active && payload && payload[0] && payload[0].payload) {
        return (
            <div className="custom-tooltip">
                <p><b>{payload[0].payload[dateKey]}</b></p>
                <p style={{ color: payload[0].color }}>{`${formatCapitalized(dataKey)}: ${formatNumber(payload[0].payload[dataKey] || 0)}`}</p>
            </div>
        );
    }
    return null;
}

